import React, { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { SupportButton } from '../../../../../containers/SupportButton/component';
import { ErrorState } from '../../../../error-boundary-context/types';
import { useCurrentError } from '../../../../error-boundary-context/context';
import { ErrorOverlayBody } from '../../error/error-overlay-body/component';
import { ErrorOverlay } from '../../error/error-overlay/component';
import { useRefreshCount } from '../../../hooks/refresh/use-refresh-count';
import styles from '../styles.module.css';
import { RefreshButton } from '../../../../RefreshButton/component';

import { getOverlayBottom } from './utils';

interface DefaultErrorProps {
    mainText?: ReactNode;
}

export const DefaultError: React.FC<DefaultErrorProps> = ({ mainText }) => {
    const intl = useIntl();

    const { vsid, sessionId, name } = useCurrentError() as {
        vsid?: string;
        sessionId?: string;
        name: ErrorState['name'];
    };

    const { isSupportShown, refresh } = useRefreshCount();

    return (
        <ErrorOverlay>
            <ErrorOverlayBody>
                <div className={styles.mainText}>
                    {mainText || (
                        <FormattedMessage
                            id="features.player.069fd1a242baee05f3e4e273a5a491fc"
                            defaultMessage="<div>Something went wrong on our side.</div><div>Try refreshing.</div>"
                            description="Текст ошибки по-умолчанию в плеере"
                            values={{
                                // eslint-disable-next-line react/no-unstable-nested-components
                                div: (chunks: ReactNode) => <div>{chunks}</div>,
                            }}
                        />
                    )}
                </div>
                <span className={styles.buttonRow}>
                    <span className={styles.button}>
                        <RefreshButton onClick={refresh} />
                    </span>
                    {isSupportShown && <SupportButton isLink />}
                </span>
            </ErrorOverlayBody>
            {isSupportShown && getOverlayBottom(intl, vsid, sessionId, name ?? undefined)}
        </ErrorOverlay>
    );
};
